import { render, staticRenderFns } from "./purchaseRecord.vue.js?vue&type=template&id=c6504042&scoped=true!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./purchaseRecord.vue?vue&type=template&id=c6504042&scoped=true"
import script from "./purchaseRecord.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./purchaseRecord.vue?vue&type=script&lang=js"
export * from "./purchaseRecord.vue.js?vue&type=script&lang=js!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./purchaseRecord.vue?vue&type=script&lang=js"
import style0 from "./purchaseRecord.vue.scss?vue&type=style&index=0&id=c6504042&lang=scss&scoped=true!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./purchaseRecord.vue?vue&type=style&index=0&id=c6504042&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6504042",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/web-hok_Mssh/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c6504042')) {
      api.createRecord('c6504042', component.options)
    } else {
      api.reload('c6504042', component.options)
    }
    module.hot.accept("./purchaseRecord.vue.js?vue&type=template&id=c6504042&scoped=true!=!../../../../../../node_modules/.pnpm/vue-loader@15.11.1_7oqlvuz5ddsjz7xbds5tjgd5iy/node_modules/vue-loader/lib/index.js??vue-loader-options!./purchaseRecord.vue?vue&type=template&id=c6504042&scoped=true", function () {
      api.rerender('c6504042', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/live/liveRoom/components/Dialog/purchaseRecord.vue"
export default component.exports